/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';
import { USER_UPDATE_FIELDS } from './users.shared';

export const LOGIN_USER = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      accessToken
      refreshToken
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(email: $email) {
      success
    }
  }
`;

export const GET_PASSWORD_RESET = gql`
  query ($token: String!) {
    getPasswordReset(token: $token) {
      acceptedTos
      marketingConsent
      haveSetPasswordBefore
    }
  }
`;

export const SET_PASSWORD = gql`
  mutation SetPassword($token: String!, $password: String!, $passwordRepeat: String!, $marketingConsent: Boolean) {
    setPassword(token: $token, password: $password, passwordRepeat: $passwordRepeat, marketingConsent: $marketingConsent) {
      success
    }
  }
`;

export const GET_USERS_FOR_PROPCOMP = gql`
  query {
    users {
      id
      firstName
      lastName
      email
      userType
      userRole
      acceptedTosAt
      displayColour
      createdAt
      deletedAt
    }
  }
`;

export const GET_USER_FOR_PROPCOMP = gql`
  query ($id: String!) {
    user(id: $id) {
      id
      firstName
      lastName
      email
      mobile
      userType
      userRole
      displayColour
      settings
      acceptedTosAt
      createdAt
      deletedAt
      userRelations {
        relationType
        createdAt
      }
    }
  }
`;

export const GET_OWNER_USER_FOR_PROPCOMP = gql`
  query ($id: String!) {
    clientOwnerUser(id: $id) {
      id
      firstName
      lastName
      email
      userType
      userRole
      displayColour
      settings
      acceptedTosAt
      createdAt
      deletedAt
      userRelations {
        relationType
        createdAt
      }
      owner {
        id
        displayName
      }
    }
  }
`;

export const GET_ACTIVE_USERS_FOR_PROPCOMP = gql`
  query {
    activeUsers {
      id
      firstName
      lastName
      displayColour
    }
  }
`;

export const CREATE_USER_FOR_PROPCOMP = gql`
  mutation ($firstName: String!, $lastName: String!, $email: String!, $userRole: String!, $displayColour: String) {
    createUser(input: {
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      userRole: $userRole,
      displayColour: $displayColour,
    }) {
      id
    }
  }
`;

export const DELETE_USER_FOR_PROPCOMP = gql`
  mutation ($id: String!) {
    deleteUser(id: $id)
  }
`;

export const DELETE_OWNER_USER_FOR_PROPCOMP = gql`
  mutation DeleteOwnerUser($id: String!, $ownerId: String!) {
    clientDeleteOwnerUser(id: $id, ownerId: $ownerId)
  }
`;

export const UPDATE_CLIENT_USER = gql`
  ${USER_UPDATE_FIELDS}
  mutation ($id: String!, $firstName: String!, $lastName: String!, $email: String!, $userRole: String!, $displayColour: String) {
    updateClientUser(input: {
      id: $id,
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      userRole: $userRole,
      displayColour: $displayColour,
    }) {
      ...UserUpdateFields
    }
  }
`;

export const UPDATE_OWNER_USER_FOR_PROPCOMP = gql`
  ${USER_UPDATE_FIELDS}
  mutation ($ownerId: String!, $id: String!, $firstName: String!, $lastName: String!, $email: String!, $userRole: String!, $displayColour: String) {
    clientUpdateOwnerUser(ownerId: $ownerId, input: {
      id: $id,
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      userRole: $userRole,
      displayColour: $displayColour,
    }) {
      ...UserUpdateFields
    }
  }
`;

export const UPDATE_USER_SETTINGS = gql`
  mutation UpdateUserSettings($settings: UserSettingsJSON) {
    updateUserSettings(input: { settings: $settings }) {
      success
    }
  }
`;

export const UPDATE_USER_MOBILE = gql`
  mutation ($mobile: String!) {
    updateUserMobile(mobile: $mobile) {
      success
      mobileChanged
    }
  }
`;

export const SAVE_USER_PREFERENCES = gql`
  mutation SaveUserPreferences($input: SaveUserPreferencesInput!) {
    saveUserPreferences(input: $input) {
      success
      user {
        id
        firstName
        lastName
        email
        mobile
        settings
      }
      whatsapp {
        enabled
        verified
        address
      }
    }
  }
`;

export const RESEND_USER_INVITATION_FOR_PROPCOMP = gql`
  mutation ($id: String!) {
    resendUserInvitation(id: $id)
  }
`;

export const RESEND_OWNER_INVITATION_FOR_PROPCOMP = gql`
  mutation ($id: String!, $ownerId: String!) {
    resendOwnerUserInvitation(id: $id, ownerId: $ownerId)
  }
`;
